import { render, staticRenderFns } from "./TextRenderer.vue?vue&type=template&id=6745081e&scoped=true"
import script from "./TextRenderer.vue?vue&type=script&lang=js"
export * from "./TextRenderer.vue?vue&type=script&lang=js"
import style0 from "./TextRenderer.vue?vue&type=style&index=0&id=6745081e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6745081e",
  null
  
)

export default component.exports